module.exports = __webpack_public_path__ + "static/sk-gaming-5824ebe5b51af983438bf6b36f1f5974.jpg";